<template>
    <span class="switcher">
        <input id="switcherEco" type="checkbox" v-model="input">
        <label for="switcherEco">
            <span class="switcher__effect"></span>
            <template v-if="this.etat">
                {{ switcherMessageDesactive }}
            </template>
            <template v-else>
                {{ switcherMessageActive }}
            </template>
        </label>
    </span>
</template>
<script>
export default {
  name: 'EcoSwitcher',
  props: ['current', 'etat'],
  data () {
    return {
        input: this.etat,
        switcherMessageActive:'Activer l\'éco-mode',
        switcherMessageDesactive:'Désactiver l\'éco-mode'
    }
  }, 
  watch : {
    input : function() {
        //this.$parent.$emit('updateEtat', this.input);
        if(this.input == true) { enableModeEco(); } else { disableModeEco(); }
    }
  }
}
</script>
<style scoped>
.switcher {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top:30px;
}
.switcher label {
    display: flex;
    align-items: center;
    cursor:pointer;
    font-weight: bold;
}
.switcher input {
    appearance: none;
    display: none;
    visibility: hidden;
}
.switcher__effect {
    width:45px;
    height:25px;
    display:flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    border:1px solid #606C38;
    position: relative;
    transition:all .4s ease-in-out;
    margin-right:10px;
}
.switcher__effect:before {
    content:'';
    background:#DEE6E9;
    border-radius:50px;
    width:36px;
    height:18px;
    transition:all .4s ease-in-out;
}
.switcher__effect:after {
    content:'';
    background:#606C38;
    border-radius:50px;
    width:14px;
    height:14px;
    position: absolute;
    left:9px;
    transition:all .4s ease-in-out;
}
.switcher input[type="checkbox"]:checked ~ label .switcher__effect:before {
    background:#606C38;
}

.switcher input[type="checkbox"]:checked ~ label .switcher__effect:after {
    background:#B8E994;
    right:8px;
    left:auto;
}
</style>